/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_Key_RejectedInputs */

const en_ui_integration_status_key_rejected = /** @type {(inputs: Ui_Integration_Status_Key_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key rejected`)
};

const de_ui_integration_status_key_rejected = /** @type {(inputs: Ui_Integration_Status_Key_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Key abgelehnt`)
};

/**
* | output |
* | --- |
* | "Key rejected" |
*
* @param {Ui_Integration_Status_Key_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_key_rejected = /** @type {((inputs?: Ui_Integration_Status_Key_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_Key_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_key_rejected(inputs)
	return de_ui_integration_status_key_rejected(inputs)
});